import { createSelector } from 'reselect';

const authorizationDomain = (state) => state.authorization;

const authRegisterDomain = createSelector(
  authorizationDomain,
  (auth) => auth.register,
);

const registrationDomain = createSelector(
  authorizationDomain,
  (authorization) => authorization.register,
);

export const registrationErrorMessageSelector = createSelector(
  registrationDomain,
  (register) => register.error,
);

export const registrationSuccessMessageSelector = createSelector(
  registrationDomain,
  (register) => register.success,
);

export const registrationIsFetchingSelector = createSelector(
  authRegisterDomain,
  (register) => register.isFetching,
);

// Preorder texts selectors
const generalDomain = (state) => state.general;

const preorderTextsDomain = createSelector(
  generalDomain,
  (general) => general.preorderTexts,
);

export const preorderProductTitleTextSelector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderProductTitleText,
);

export const preorderProductTextSelector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderProductText,
);

export const preorderProductButtonTextSelector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderProductButtonText,
);

export const preorderCartRadioboxTitleSelector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderCartRadioboxTitle,
);

export const preorderCartRadioboxVersion1Selector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderCartRadioboxVersion1,
);

export const preorderCartRadioboxVersion2Selector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts?.preorderCartRadioboxVersion2,
);

export const preorderTextsSelector = createSelector(
  preorderTextsDomain,
  (preorderTexts) => preorderTexts,
);
